// extracted by mini-css-extract-plugin
export default {"table":"interest-crediting-rates_table__-uCRR","caption":"interest-crediting-rates_caption__bE6W8","from-to-label":"interest-crediting-rates_from-to-label__PzYvf"};